/* ============================================================
 * NOVATRACKERS — comportamento das seções da home.
 *   <nt-video>   fachada do YouTube + tela cheia
 *   <nt-marquee> faixa infinita com velocidade constante em px/s
 *   <nt-drag>    carrossel com arraste do mouse
 *   contadores animados (easeOutQuint)
 * ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Fachada do YouTube ------------------------------
   * O iframe só entra no DOM no clique: nenhum script nem cookie
   * de terceiro antes da interação do visitante.
   * ----------------------------------------------------------- */
  if (!customElements.get('nt-video')) {
    customElements.define(
      'nt-video',
      class extends HTMLElement {
        connectedCallback() {
          var play = this.querySelector('[data-nt-play]');
          if (play) play.addEventListener('click', this.play.bind(this), { once: true });

          var full = this.parentElement && this.parentElement.querySelector('[data-nt-fullscreen]');
          if (full) {
            full.addEventListener('click', function () {
              if (this.requestFullscreen) this.requestFullscreen();
            }.bind(this));
          }
        }

        play() {
          var id = this.dataset.id;
          if (!id) return;

          // enablejsapi: abre o canal de postMessage do player, que e como
          // o volume inicial e ajustado abaixo.
          var iframe = document.createElement('iframe');
          iframe.src =
            'https://www.youtube.com/embed/' +
            encodeURIComponent(id) +
            '?autoplay=1&rel=0&modestbranding=1&playsinline=1&enablejsapi=1';
          iframe.title = 'YouTube';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          iframe.allowFullscreen = true;
          iframe.className = 'nt-video__frame';
          var play = this.querySelector('[data-nt-play]');
          if (play) play.replaceWith(iframe);

          // O player do YouTube nasce em 100%. A ordem vai pelo proprio
          // protocolo postMessage da API deles, e nao pelo script
          // iframe_api — carregar aquele script anularia a fachada, que
          // existe para nao trazer terceiro antes da interacao.
          var volume = parseInt(this.dataset.volume, 10);
          if (!(volume >= 0 && volume <= 100)) return;

          function ordenar() {
            if (!iframe.contentWindow) return;
            iframe.contentWindow.postMessage(
              JSON.stringify({ event: 'command', func: 'setVolume', args: [volume] }),
              'https://www.youtube.com'
            );
          }

          // O player so aceita comando depois de pronto, e sem o script da
          // API nao ha evento confiavel para esperar. Entao repete por
          // ~2,4s e para — o custo de uma mensagem ignorada e zero.
          iframe.addEventListener('load', function () {
            var tentativas = 0;
            var relogio = setInterval(function () {
              ordenar();
              if (++tentativas >= 8) clearInterval(relogio);
            }, 300);
          });
        }
      }
    );
  }

  /* ---------- Faixa infinita ----------------------------------
   * Duplica a sequência até cobrir a viewport e calcula a duração a
   * partir da largura real, para a velocidade ficar constante em
   * qualquer tela (JogosCompativeis.tsx:58-92).
   * ----------------------------------------------------------- */
  if (!customElements.get('nt-marquee')) {
    customElements.define(
      'nt-marquee',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-nt-track]');
          if (!this.track || reduceMotion) return;

          this.original = this.track.innerHTML;
          this.originalCount = this.track.children.length;
          this.gap = parseFloat(getComputedStyle(this.track).columnGap) || 24;
          this.speed = Number(this.dataset.speed) || 60;

          this.recalc = this.recalc.bind(this);
          this.recalc();

          if ('ResizeObserver' in window) {
            // Só o elemento externo. Observar o trilho criaria laço:
            // recalc() altera o trilho, que dispararia o observer de novo.
            this.ro = new ResizeObserver(this.recalc);
            this.ro.observe(this);
          }
          window.addEventListener('resize', this.recalc);
        }

        disconnectedCallback() {
          if (this.ro) this.ro.disconnect();
          window.removeEventListener('resize', this.recalc);
        }

        recalc() {
          // Restaura uma sequência para medir a largura real dela.
          this.track.innerHTML = this.original;
          var seq = this.track.scrollWidth;
          var viewport = this.clientWidth;

          // A primeira medição pode cair antes do layout assentar. Em vez de
          // desistir em silêncio, tenta de novo por até ~2s. Não dá para usar
          // requestAnimationFrame aqui: ele fica congelado em aba inativa.
          if (seq <= 0 || viewport <= 0) {
            this.tries = (this.tries || 0) + 1;
            if (this.tries < 20) setTimeout(this.recalc, 100);
            return;
          }
          this.tries = 0;

          // No editor de temas não duplicamos: as cópias carregariam os
          // mesmos data-shopify-editor-block dos blocks originais e o
          // editor perderia a referência ao arrastar.
          if (window.Shopify && window.Shopify.designMode) return;

          // Uma sequência a mais que o necessário garante loop contínuo.
          var copies = Math.max(2, Math.ceil(viewport / seq) + 1);
          var html = '';
          for (var i = 0; i < copies; i++) html += this.original;
          this.track.innerHTML = html;

          // As cópias são decorativas: só a primeira sequência é anunciada.
          var items = this.track.children;
          for (var j = seq && this.originalCount ? this.originalCount : 0; j < items.length; j++) {
            items[j].setAttribute('aria-hidden', 'true');
          }

          // A sequência termina sem gap final: somar um para o salto fechar.
          var distance = seq + this.gap;
          this.track.style.setProperty('--nt-marquee-distance', distance + 'px');
          this.track.style.setProperty('--nt-marquee-duration', distance / this.speed + 's');
        }
      }
    );
  }

  /* ---------- Carrossel com arraste ---------------------------- */
  if (!customElements.get('nt-drag')) {
    customElements.define(
      'nt-drag',
      class extends HTMLElement {
        connectedCallback() {
          this.pointerId = null;
          this.startX = 0;
          this.startScroll = 0;
          this.moved = false;

          this.addEventListener('pointerdown', this.onDown.bind(this));
          this.addEventListener('pointermove', this.onMove.bind(this));
          this.addEventListener('pointerup', this.onUp.bind(this));
          this.addEventListener('pointercancel', this.onUp.bind(this));
          // Um arraste não pode virar clique no link do card.
          this.addEventListener(
            'click',
            function (event) {
              if (!this.moved) return;
              event.preventDefault();
              event.stopPropagation();
              this.moved = false;
            }.bind(this),
            true
          );
          this.addEventListener('dragstart', function (e) { e.preventDefault(); });

          var nav = this.parentElement && this.parentElement.querySelector('.nt-products__nav');
          if (nav) {
            var prev = nav.querySelector('[data-nt-prev]');
            var next = nav.querySelector('[data-nt-next]');
            if (prev) prev.addEventListener('click', this.step.bind(this, -1));
            if (next) next.addEventListener('click', this.step.bind(this, 1));
            this.nav = { prev: prev, next: next };
            this.sync = this.sync.bind(this);
            this.addEventListener('scroll', this.sync, { passive: true });
            window.addEventListener('resize', this.sync);
            this.sync();
          }
        }

        disconnectedCallback() {
          if (this.sync) window.removeEventListener('resize', this.sync);
        }

        onDown(event) {
          if (event.pointerType === 'touch') return; // toque usa o scroll nativo
          this.pointerId = event.pointerId;
          this.startX = event.clientX;
          this.startScroll = this.scrollLeft;
          this.moved = false;
          this.classList.add('is-dragging');
        }

        onMove(event) {
          if (this.pointerId !== event.pointerId) return;
          var dx = event.clientX - this.startX;
          if (Math.abs(dx) > 6) {
            this.moved = true;
            if (!this.hasPointerCapture(event.pointerId)) this.setPointerCapture(event.pointerId);
          }
          if (!this.moved) return;
          this.scrollLeft = this.startScroll - dx;
        }

        onUp(event) {
          if (this.pointerId !== event.pointerId) return;
          if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
          this.pointerId = null;
          this.classList.remove('is-dragging');
        }

        step(dir) {
          var card = this.querySelector('[data-nt-card]');
          var gap = parseFloat(getComputedStyle(this).columnGap) || 24;
          var amount = card ? card.offsetWidth + gap : this.clientWidth * 0.8;
          this.scrollBy({ left: dir * amount, behavior: reduceMotion ? 'auto' : 'smooth' });
        }

        sync() {
          if (!this.nav) return;
          if (this.nav.prev) this.nav.prev.disabled = this.scrollLeft <= 4;
          if (this.nav.next) {
            this.nav.next.disabled = this.scrollLeft + this.clientWidth >= this.scrollWidth - 4;
          }
        }
      }
    );
  }

  /* ---------- <nt-scroll> -------------------------------------
   * Indicador de rolagem com o gradiente da marca. A barra nativa é
   * escondida pelo CSS e o polegar é posicionado aqui.
   * Porte de GradientScrollArea (ReviewsApple.tsx:157-212).
   * ----------------------------------------------------------- */
  if (!customElements.get('nt-scroll')) {
    customElements.define(
      'nt-scroll',
      class extends HTMLElement {
        connectedCallback() {
          this.area = this.querySelector('[data-nt-scroll-area]');
          this.track = this.querySelector('[data-nt-scroll-track]');
          this.thumb = this.querySelector('[data-nt-scroll-thumb]');
          if (!this.area || !this.track || !this.thumb) return;

          this.update = this.update.bind(this);
          this.area.addEventListener('scroll', this.update, { passive: true });

          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(this.update);
            this.ro.observe(this.area);
            // O conteúdo é que define scrollHeight; sem observá-lo, uma
            // fonte que carrega depois deixaria o indicador desatualizado.
            if (this.area.firstElementChild) this.ro.observe(this.area.firstElementChild);
          }
          window.addEventListener('resize', this.update);
          this.update();
        }

        disconnectedCallback() {
          if (this.ro) this.ro.disconnect();
          window.removeEventListener('resize', this.update);
        }

        update() {
          var el = this.area;
          var altura = el.scrollHeight;

          // Sem transbordo, nada de indicador.
          if (altura <= el.clientHeight + 1) {
            this.track.classList.remove('is-visible');
            return;
          }
          this.track.classList.add('is-visible');

          var razao = el.clientHeight / altura;
          var topo = el.scrollTop / altura;
          // Piso de 12% para o polegar não sumir em textos muito longos.
          this.thumb.style.height = Math.max(razao * 100, 12) + '%';
          this.thumb.style.top = topo * 100 + '%';
        }
      }
    );
  }

  /* ---------- <nt-passos> -------------------------------------
   * Um passo por vez num tutorial, com trilha de progresso.
   *
   * Sem JS todos os passos ficam visíveis, na ordem, numerados — que é o
   * estado correto para busca, leitor de tela e impressão. Este elemento
   * REDUZ isso a um passo por vez; ele não constrói nada.
   *
   * `data-nt-solto` desliga o assistente: a página índice usa a mesma seção
   * para listar tutoriais em vez de ensinar uma sequência.
   * ----------------------------------------------------------- */
  if (!customElements.get('nt-passos')) {
    customElements.define(
      'nt-passos',
      class extends HTMLElement {
        connectedCallback() {
          if (this.hasAttribute('data-nt-solto')) return;
          /* TELAS, e nao passos. Uma pergunta ocupa uma tela do fluxo mas nao
             e um passo: ela nao recebe numero, porque numerar "voce tem
             trackers de braco?" faria a pessoa procurar o que executar num
             lugar onde nao ha nada a fazer. */
          this.telas = Array.prototype.slice.call(this.querySelectorAll('[data-nt-tela]'));
          if (this.telas.length < 2) return;
          this.pulados = {};

          this.botoes = Array.prototype.slice.call(this.querySelectorAll('[data-nt-ir]'));
          this.barras = Array.prototype.slice.call(this.querySelectorAll('[data-nt-barra]'));
          this.contas = Array.prototype.slice.call(this.querySelectorAll('[data-nt-conta]'));
          this.prev = this.querySelector('[data-nt-prev]');
          this.next = this.querySelector('[data-nt-next]');

          this.botoes.forEach(
            function (bt) {
              bt.addEventListener(
                'click',
                function () {
                  this.ir(Number(bt.getAttribute('data-nt-ir')) - 1, true);
                }.bind(this)
              );
            }.bind(this)
          );
          if (this.prev) this.prev.addEventListener('click', this.andar.bind(this, -1));
          if (this.next) this.next.addEventListener('click', this.andar.bind(this, 1));

          // Setas do teclado. Só quando o foco está dentro da seção e não num
          // campo: um tutorial não tem campo hoje, mas roubar as setas de um
          // <input> futuro seria um bug silencioso e chato de achar.
          this.addEventListener('keydown', function (e) {
            if (e.target.closest('input, textarea, select')) return;
            if (e.key === 'ArrowRight') this.andar(1);
            else if (e.key === 'ArrowLeft') this.andar(-1);
            else return;
            e.preventDefault();
          }.bind(this));

          /* As perguntas. Responder "nao tenho" apaga os passos daquele grupo
             e o resto se renumera: sem isso a contagem mentiria a partir dali,
             e a trilha listaria passos que a pessoa nunca vai ver. */
          this.querySelectorAll('[data-nt-resposta]').forEach(
            function (bt) {
              bt.addEventListener(
                'click',
                function () {
                  var tela = bt.closest('[data-nt-pergunta]');
                  var grupo = tela.getAttribute('data-nt-pergunta');
                  this.pulados[grupo] = bt.getAttribute('data-nt-resposta') === 'nao';
                  tela.querySelectorAll('[data-nt-resposta]').forEach(function (o) {
                    o.setAttribute('aria-pressed', o === bt ? 'true' : 'false');
                  });
                  this.recontar();
                  /* Segue para a proxima tela viva. Ficar parado depois de
                     responder faria a pessoa procurar o que fazer com a
                     resposta que acabou de dar. */
                  var i = this.vivas.indexOf(tela);
                  this.ir(Math.min(i + 1, this.vivas.length - 1), true);
                }.bind(this)
              );
            }.bind(this)
          );

          this.setAttribute('data-nt-pronto', '');
          this.recontar();
          this.ir(this.doEndereco(), false);
        }

        /* Refaz a lista viva e a numeracao. Chamado no inicio e a cada
           resposta: os numeros vem do servidor com TODOS os passos, que e o
           estado correto sem JS, e sao reescritos aqui quando um grupo sai. */
        recontar() {
          var pulados = this.pulados;
          this.vivas = this.telas.filter(function (el) {
            var g = el.getAttribute('data-nt-grupo');
            return !(g && pulados[g]);
          });

          var modelo = this.getAttribute('data-nt-modelo') || 'Passo {n} de {total}';
          var passos = this.vivas.filter(function (el) { return el.hasAttribute('data-nt-passo'); });
          this.passosVivos = passos;
          passos.forEach(function (el, k) {
            var n = el.querySelector('.nt-pas__marca-n[data-nt-n]');
            var m = el.querySelector('[data-nt-marca]');
            if (n) n.textContent = String(k + 1);
            if (m) {
              m.textContent = modelo
                .replace('{n}', String(k + 1))
                .replace('{total}', String(passos.length));
            }
          });

          // A trilha acompanha: entrada de passo pulado some, e a numeracao
          // das que ficaram e refeita na mesma conta.
          var botoes = Array.prototype.slice.call(this.querySelectorAll('[data-nt-ir]'));
          var i = 0;
          botoes.forEach(function (bt) {
            var g = bt.getAttribute('data-nt-trilha-grupo');
            var fora = g && pulados[g];
            if (fora) bt.setAttribute('data-nt-pulado', '');
            else bt.removeAttribute('data-nt-pulado');
            if (fora || bt.hasAttribute('data-nt-trilha-pergunta')) return;
            i += 1;
            var n = bt.querySelector('[data-nt-n]');
            if (n) n.textContent = String(i);
          });
          this.botoes = botoes.filter(function (bt) { return !bt.hasAttribute('data-nt-pulado'); });

          // A tela aberta pode ter acabado de ser pulada.
          if (this.atual === undefined) return;
          var alvo = this.telas[this.atual];
          if (this.vivas.indexOf(alvo) < 0) this.ir(Math.min(this.atual, this.vivas.length - 1), true);
        }

        /* #passo-3 no endereço abre direto no passo 3. É o que permite o
           suporte mandar "veja o passo 4" com um link em vez de instruções
           para chegar lá. */
        doEndereco() {
          var m = /^#passo-(\d+)$/.exec(window.location.hash || '');
          if (!m) return 0;
          var alvo = this.querySelector('[data-nt-passo="' + Number(m[1]) + '"]');
          var i = alvo ? this.vivas.indexOf(alvo) : -1;
          return i >= 0 ? i : 0;
        }

        andar(delta) {
          this.ir(this.atual + delta, true);
        }

        ir(i, mover) {
          if (i < 0 || i >= this.vivas.length) return;
          this.atual = i;
          var viva = this.vivas[i];

          this.telas.forEach(function (p) {
            p.hidden = p !== viva;
          });

          this.botoes.forEach(function (bt, k) {
            if (k === i) bt.setAttribute('aria-current', 'step');
            else bt.removeAttribute('aria-current');
            // Visto no que ficou para trás, e não em tudo: a trilha inteira
            // acesa não aponta para lugar nenhum.
            if (k < i) bt.setAttribute('data-nt-visto', '');
            else bt.removeAttribute('data-nt-visto');
          });

          /* A CONTA E DE PASSOS, e nao de telas.

             A tela de pergunta nao e passo e nao recebe numero. Se o rodape
             contasse telas, ele diria "6 de 10" enquanto o painel diz "Passo 5
             de 9": dois numeros para a mesma coisa, na mesma tela. Aqui os
             dois olham para a mesma lista.

             Na tela de pergunta a conta some — nao ha passo a numerar — e a
             barra fica onde o ultimo passo deixou. */
          var passos = this.passosVivos || this.vivas;
          var quantos = passos.length;
          var k = passos.indexOf(viva);
          var antes = k >= 0 ? k : this.vivas.slice(0, i).filter(function (el) {
            return el.hasAttribute('data-nt-passo');
          }).length - 1;
          var pct = quantos ? Math.round(((antes + 1) / quantos) * 100) : 0;
          this.barras.forEach(function (b) {
            b.style.setProperty('--nt-pas-pct', Math.max(0, pct) + '%');
          });
          this.contas.forEach(function (c) {
            c.textContent = k >= 0 ? k + 1 + ' de ' + quantos : '';
          });

          if (this.prev) this.prev.disabled = i === 0;
          if (this.next) this.next.disabled = i === this.vivas.length - 1;

          if (!mover) return;

          /* `replaceState` e não `pushState`: o botão voltar do navegador tem
             de sair do tutorial, e não desfazer passo a passo doze vezes. */
          if (window.history && window.history.replaceState) {
            var num = viva.getAttribute('data-nt-passo');
            if (num) window.history.replaceState(null, '', '#passo-' + num);
          }

          /* Sobe até o alto da seção quando ela saiu da tela. Sem isto,
             avançar a partir de um passo comprido deixa a pessoa no meio do
             passo novo, olhando para o miolo de um texto que ela não começou
             a ler. */
          var caixa = this.getBoundingClientRect();
          if (caixa.top < 0 || caixa.top > window.innerHeight * 0.5) {
            this.scrollIntoView({ block: 'start', behavior: 'smooth' });
          }
          viva.focus({ preventScroll: true });
        }
      }
    );
  }

  /* ---------- <nt-reviews> ------------------------------------
   * Paginação simples da grade. Sem JS, todas as avaliações ficam
   * visíveis — que é o estado correto para busca e leitor de tela.
   * ----------------------------------------------------------- */
  if (!customElements.get('nt-reviews')) {
    customElements.define(
      'nt-reviews',
      class extends HTMLElement {
        connectedCallback() {
          this.size = this.porPagina();
          this.ordenar();
          this.recolher();

          this.page = 0;

          var foot = this.parentElement;
          this.prev = foot && foot.querySelector('[data-nt-rev-prev]');
          this.next = foot && foot.querySelector('[data-nt-rev-next]');
          this.dotbar = foot && foot.querySelector('[data-nt-rev-dots]');

          if (this.prev) this.prev.addEventListener('click', this.go.bind(this, -1));
          if (this.next) this.next.addEventListener('click', this.go.bind(this, 1));

          // Um ponto por página. Criados aqui porque o Liquid não sabe
          // quantas páginas existem — isso depende do page_size.
          this.montarPontos();
          this.render();

          // quantos cartões por página sai do css e muda com a largura da tela
          this.redimensionou = this.acompanharLargura.bind(this);
          window.addEventListener('resize', this.redimensionou);
        }

        disconnectedCallback() {
          if (this.redimensionou) window.removeEventListener('resize', this.redimensionou);
        }

        // --nt-rev-por-pagina: 4 a partir de 1200px, 3 até 1024, 1 no celular. o ajuste da seção é só reserva
        porPagina() {
          var css = parseInt(getComputedStyle(this).getPropertyValue('--nt-rev-por-pagina'), 10);
          return css > 0 ? css : Number(this.dataset.pageSize) || 6;
        }

        // mudou o número por página: a avaliação que abria a página quando a pessoa navegou continua na
        // tela. a âncora não anda com a largura, para ida e volta entre tamanhos não deslizar
        acompanharLargura() {
          var novo = this.porPagina();
          if (novo === this.size || !this.cards) return;
          var primeiro = this.ancora != null ? Math.min(this.ancora, this.cards.length - 1) : this.page * this.size;
          this.size = novo;
          this.pages = Math.max(1, Math.ceil(this.cards.length / this.size));
          this.page = Math.max(0, Math.min(this.pages - 1, Math.floor(primeiro / this.size)));
          this.montarPontos();
          this.render();
        }

        /* Mais recente primeiro, e nao a ordem em que o Liquid emitiu.

           O Liquid emite primeiro as do metaobject e depois as do Judge.me, e
           dentro de cada grupo em ordem propria. As do Judge.me sao as mais
           novas de todas, entao sem ordenar elas cairiam nas ultimas paginas.

           Ordenar aqui e nao no Liquid porque as duas fontes tem forma
           diferente — metaobject e objeto de JSON — e o Liquid nao sabe juntar
           e ordenar as duas listas por data. Cada cartao carrega a data em
           data-nt-quando, no formato ano-mes-dia, que ordena como texto.

           Cartao sem data vai para o fim: melhor que embaralhar. */
        ordenar() {
          var todos = Array.prototype.slice.call(this.querySelectorAll('[data-nt-review]'));
          if (todos.length < 2) return;
          var ordenados = todos.slice().sort(function (a, b) {
            // com foto ou vídeo primeiro, depois sem mídia; a data decide dentro de cada grupo
            var ma = a.dataset.ntMidia === '1' ? 1 : 0;
            var mb = b.dataset.ntMidia === '1' ? 1 : 0;
            if (ma !== mb) return mb - ma;
            var da = a.dataset.ntQuando || '';
            var db = b.dataset.ntQuando || '';
            if (!da && !db) return 0;
            if (!da) return 1;
            if (!db) return -1;
            return db.localeCompare(da);
          });
          var mudou = ordenados.some(function (c, i) { return c !== todos[i]; });
          if (!mudou) return;
          var caixa = document.createDocumentFragment();
          ordenados.forEach(function (c) { caixa.appendChild(c); });
          this.appendChild(caixa);
        }

        /* Cartao com data-nt-fora esta escondido por uma aba, entao nao entra
           na conta das paginas. Sem isto, trocar de aba deixava paginas vazias:
           a paginacao continuava contando a lista inteira. */
        montarPontos() {
          if (!this.dotbar) { this.dots = []; return; }
          this.dotbar.textContent = '';
          this.dots = [];
          if (this.pages < 2) return;
          for (var i = 0; i < this.pages; i++) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'nt-rev__dot';
            dot.setAttribute('role', 'tab');
            dot.setAttribute('aria-label', 'Página ' + (i + 1));
            dot.addEventListener('click', this.to.bind(this, i));
            this.dotbar.appendChild(dot);
            this.dots.push(dot);
          }
        }

        recolher() {
          var todos = Array.prototype.slice.call(this.querySelectorAll('[data-nt-review]'));
          this.cards = todos.filter(function (c) { return !c.dataset.ntFora; });
          todos.forEach(function (c) {
            if (c.dataset.ntFora) c.hidden = true;
          });
          this.pages = Math.max(1, Math.ceil(this.cards.length / this.size));
        }

        reset() {
          this.recolher();
          this.page = 0;
          this.ancora = 0;
          this.montarPontos();
          this.render();
        }

        go(delta) {
          this.to(Math.min(this.pages - 1, Math.max(0, this.page + delta)));
        }

        /* Trocar de pagina NAO rola a tela. Havia um scrollIntoView aqui que
           levava a grade para o topo da janela, e como a grade comeca abaixo do
           resumo, o efeito era a pagina descer sozinha a cada clique no
           paginador. O original nao faz isso: o go() dele so troca a pagina
           (ReviewsApple.tsx:820). */
        to(page) {
          this.page = page;
          this.ancora = page * this.size;
          this.render();
        }

        render() {
          var start = this.page * this.size;
          this.cards.forEach(function (card, i) {
            card.hidden = i < start || i >= start + this.size;
          }, this);
          /* O paginador some quando cabe tudo numa pagina. */
          if (this.parentElement) {
            var pager = this.parentElement.querySelector('.nt-rev__pager');
            if (pager) pager.hidden = this.pages < 2;
          }
          if (this.prev) this.prev.disabled = this.page === 0;
          if (this.next) this.next.disabled = this.page >= this.pages - 1;
          this.dots.forEach(function (dot, i) {
            var on = i === this.page;
            dot.classList.toggle('is-active', on);
            dot.setAttribute('aria-selected', on ? 'true' : 'false');
          }, this);
          /* AVISA QUEM MEDE. Cartao escondido pela paginacao mede zero, entao
             a secao so consegue calcular o clamp e decidir sobre o botao de
             "ler completa" DEPOIS que a carta aparece. Antes disso o aviso era
             um ouvinte de clique no paginador, que perdia dois casos calados:
             a primeira renderizacao, feita aqui no connectedCallback, e a
             reordenacao por data, que troca quem esta na pagina zero sem
             ninguem clicar em nada. */
          this.dispatchEvent(new CustomEvent('nt-rev-render', { bubbles: true }));
        }
      }
    );
  }

  /* ---------- <nt-faq> ----------------------------------------
   * Liga as abas do FAQ. O acordeão em si é <details> nativo e não
   * precisa de JS nenhum.
   *
   * A barra de abas nasce com hidden e os grupos com título próprio:
   * sem JS o visitante vê os dois grupos empilhados, cada um
   * identificado — nunca um conteúdo escondido sem jeito de abrir.
   * ----------------------------------------------------------- */
  if (!customElements.get('nt-faq')) {
    customElements.define(
      'nt-faq',
      class extends HTMLElement {
        connectedCallback() {
          var barra = this.querySelector('[data-nt-faq-tabs]');
          this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-nt-faq-tab]'));
          this.grupos = Array.prototype.slice.call(this.querySelectorAll('[data-nt-faq-group]'));
          if (!barra || this.tabs.length < 2) return;

          barra.hidden = false;
          this.querySelectorAll('[data-nt-faq-grouptitle]').forEach(function (t) {
            t.hidden = true;
          });

          this.tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
              this.show(tab.getAttribute('data-nt-faq-tab'));
            }.bind(this));
          }, this);

          this.show(this.tabs[0].getAttribute('data-nt-faq-tab'));
        }

        show(chave) {
          this.tabs.forEach(function (tab) {
            tab.setAttribute('aria-selected', tab.getAttribute('data-nt-faq-tab') === chave ? 'true' : 'false');
          });
          this.grupos.forEach(function (g) {
            g.hidden = g.getAttribute('data-nt-faq-group') !== chave;
          });
        }
      }
    );
  }

  /* ---------- <nt-clip> ---------------------------------------
   * Clipe mudo que só baixa e toca quando entra na tela, e pausa
   * quando sai — porte do IntersectionObserver de VejaEmAcao.tsx.
   *
   * O src fica em data-nt-clip-src, não no atributo src: com cinco
   * vídeos na home, deixar o navegador buscar todos de saída custaria
   * mais de 20 MB por visita.
   *
   * Sem JS o vídeo não carrega e sobra o poster — é o motivo de o
   * botão de play existir: iOS em economia de bateria e
   * prefers-reduced-motion também recusam o autoplay.
   * ----------------------------------------------------------- */
  if (!customElements.get('nt-clip')) {
    customElements.define(
      'nt-clip',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video[data-nt-clip-src]');
          this.button = this.querySelector('[data-nt-clip-play]');
          if (!this.video) return;

          if (this.button) {
            this.button.addEventListener('click', function () {
              this.load();
              this.play(true);
            }.bind(this));
          }

          this.video.addEventListener('error', this.fallback.bind(this));

          if (reduceMotion) {
            this.load();
            this.fallback();
            return;
          }

          if (!('IntersectionObserver' in window)) {
            this.load();
            this.play();
            return;
          }

          var io = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  this.load();
                  this.play();
                } else if (!this.video.paused) {
                  this.video.pause();
                }
              }, this);
            }.bind(this),
            { threshold: 0.25, rootMargin: '150px' }
          );
          io.observe(this);
        }

        load() {
          var src = this.video.getAttribute('data-nt-clip-src');
          if (!src || this.video.src) return;
          this.video.src = src;
          this.video.preload = 'auto';
        }

        play(manual) {
          var p = this.video.play();
          if (!p || typeof p.then !== 'function') return;
          p.then(
            function () {
              if (this.button) this.button.hidden = true;
            }.bind(this),
            function () {
              if (!manual) this.fallback();
            }.bind(this)
          );
        }

        fallback() {
          if (this.button) this.button.hidden = false;
        }
      }
    );
  }

  /* ---------- <nt-lightbox> -----------------------------------
   * Abre a mídia da avaliação em tela cheia, com navegação entre as
   * peças da MESMA avaliação e player para os vídeos.
   *
   * Um único elemento serve a página toda: o card clicado entrega a
   * lista pelo <script type="application/json" data-nt-media>. Sem JS
   * os botões não fazem nada e as miniaturas seguem visíveis.
   * ----------------------------------------------------------- */
  if (!customElements.get('nt-lightbox')) {
    customElements.define(
      'nt-lightbox',
      class extends HTMLElement {
        connectedCallback() {
          this.stage = this.querySelector('[data-nt-lb-stage]');
          this.dotbar = this.querySelector('[data-nt-lb-dots]');
          this.prevBtn = this.querySelector('[data-nt-lb-prev]');
          this.nextBtn = this.querySelector('[data-nt-lb-next]');
          this.items = [];
          this.index = 0;

          var close = this.close.bind(this);
          this.querySelector('[data-nt-lb-close]').addEventListener('click', close);
          if (this.prevBtn) this.prevBtn.addEventListener('click', this.step.bind(this, -1));
          if (this.nextBtn) this.nextBtn.addEventListener('click', this.step.bind(this, 1));

          // Clique fora do conteúdo fecha.
          this.addEventListener('click', function (e) {
            if (e.target === this || e.target === this.stage) close();
          }.bind(this));

          document.addEventListener('keydown', function (e) {
            if (this.hidden) return;
            if (e.key === 'Escape') close();
            else if (e.key === 'ArrowLeft') this.step(-1);
            else if (e.key === 'ArrowRight') this.step(1);
          }.bind(this));

          // Delegação: pega qualquer miniatura da página, inclusive as
          // que ainda estão escondidas pela paginação.
          document.addEventListener('click', function (e) {
            var trigger = e.target.closest && e.target.closest('[data-nt-open-media]');
            if (!trigger) return;
            var card = trigger.closest('[data-nt-review]');
            var json = card && card.querySelector('script[data-nt-media]');
            if (!json) return;
            var list;
            try {
              list = JSON.parse(json.textContent);
            } catch (err) {
              return;
            }
            if (!list || !list.length) return;
            e.preventDefault();
            this.open(list, Number(trigger.getAttribute('data-nt-open-media')) || 0);
          }.bind(this));
        }

        open(items, index) {
          this.items = items;
          this.index = Math.min(items.length - 1, Math.max(0, index));
          this.opener = document.activeElement;
          this.hidden = false;
          document.documentElement.classList.add('nt-lb-open');

          this.dotbar.innerHTML = '';
          this.dots = items.map(function (_, i) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'nt-lb__dot';
            dot.setAttribute('aria-label', 'Mídia ' + (i + 1));
            dot.addEventListener('click', this.to.bind(this, i));
            this.dotbar.appendChild(dot);
            return dot;
          }, this);

          var solo = items.length < 2;
          this.dotbar.hidden = solo;
          if (this.prevBtn) this.prevBtn.hidden = solo;
          if (this.nextBtn) this.nextBtn.hidden = solo;

          this.render();
        }

        close() {
          /* O retangulo da midia, medido ANTES de limpar o palco: quando o
             ouvinte de nt-lb-fechou roda, a peca ja nao existe mais, e sem
             esta medida a volta para o leitor nao teria de onde encolher. */
          var peca = this.stage.querySelector('.nt-lb__media');
          var de = null;
          if (peca) {
            var r = peca.getBoundingClientRect();
            de = { left: r.left, top: r.top, width: r.width, height: r.height };
          }

          this.hidden = true;
          this.stage.innerHTML = '';
          document.documentElement.classList.remove('nt-lb-open');
          if (this.opener && this.opener.focus) this.opener.focus();
          /* Avisa quem abriu. O leitor de avaliacoes precisa se reabrir aqui:
             ele se fecha para dar lugar ao lightbox, porque um elemento fixo
             nao consegue pintar acima de um <dialog> em camada superior. Sem
             este sinal, fechar a foto largava a pessoa na pagina, longe da
             avaliacao que ela estava lendo. */
          this.dispatchEvent(new CustomEvent('nt-lb-fechou', {
            bubbles: true,
            detail: { de: de }
          }));
        }

        step(delta) {
          if (this.items.length < 2) return;
          // Circular: da última volta para a primeira.
          this.to((this.index + delta + this.items.length) % this.items.length);
        }

        to(index) {
          this.index = index;
          this.render();
        }

        render() {
          var item = this.items[this.index];
          this.stage.innerHTML = '';

          if (item.kind === 'youtube') {
            // O player entra so aqui, no momento em que a pessoa abriu a
            // midia — e o mesmo acordo da fachada do <nt-video>: nenhum
            // script nem cookie do YouTube na pagina antes disso.
            var yt = document.createElement('iframe');
            yt.className = 'nt-lb__media nt-lb__media--yt';
            yt.src =
              'https://www.youtube.com/embed/' +
              encodeURIComponent(item.id) +
              '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
            yt.title = 'YouTube';
            yt.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
            yt.allowFullscreen = true;
            yt.setAttribute('frameborder', '0');
            this.stage.appendChild(yt);
          } else if (item.kind === 'video') {
            var video = document.createElement('video');
            video.className = 'nt-lb__media';
            video.src = item.src;
            if (item.poster) video.poster = item.poster;
            video.controls = true;
            video.playsInline = true;
            video.preload = 'metadata';
            this.stage.appendChild(video);
          } else {
            var img = document.createElement('img');
            img.className = 'nt-lb__media';
            img.src = item.src;
            img.alt = '';
            // Zoom: clicar amplia com o ponto clicado no centro.
            img.addEventListener('click', function (e) {
              var on = img.classList.toggle('is-zoom');
              if (!on) return;
              var box = img.getBoundingClientRect();
              img.style.transformOrigin =
                ((e.clientX - box.left) / box.width) * 100 + '% ' +
                ((e.clientY - box.top) / box.height) * 100 + '%';
            });
            this.stage.appendChild(img);
          }

          if (this.dots) {
            this.dots.forEach(function (dot, i) {
              dot.classList.toggle('is-active', i === this.index);
            }, this);
          }
          this.querySelector('[data-nt-lb-close]').focus();
        }
      }
    );
  }

  /* O filtro de categoria saiu daqui. Quem o tem agora e o proprio
     nt-products.liquid, no {% javascript %} dele, e a versao de la e a
     reescrita: mede a altura do carrossel, faz o rebaixamento em duas
     passadas e religa em shopify:section:load sozinha.

     Enquanto as duas existiam, as duas ligavam os mesmos [data-nt-chip].
     Este arquivo e pedido por uma tag <script src> em cada secao que o usa,
     e cada tag executa o arquivo de novo: na home eram quatro execucoes,
     entao cada chip acumulava cinco ouvintes de clique, quatro daqui e um
     de la. Medido no navegador. O estado final era o mesmo, mas quem
     escrevia por ultimo era sorteio entre duas implementacoes diferentes. */


  /* ---------- Contadores --------------------------------------
   * O HTML já traz o valor final, então scrapers e leitores de tela
   * veem o número real mesmo sem JS.
   * ----------------------------------------------------------- */
  function initCounters(root) {
    var targets = (root || document).querySelectorAll('[data-nt-count]:not([data-nt-done])');
    if (!targets.length || reduceMotion || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          count(entry.target);
        });
      },
      { threshold: 0.3 }
    );
    targets.forEach(function (el) {
      el.setAttribute('data-nt-done', '');
      io.observe(el);
    });
  }

  function count(el) {
    var to = Number(el.getAttribute('data-nt-count')) || 0;
    var suffix = el.getAttribute('data-nt-suffix') || '';
    var delay = Number(el.getAttribute('data-nt-delay')) || 0;
    var duration = 3200;
    var start = performance.now() + delay;

    el.textContent = '0' + suffix;
    (function tick(now) {
      if (now < start) return requestAnimationFrame(tick);
      var p = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - p, 5); // easeOutQuint
      el.textContent = Math.round(to * eased) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    })(performance.now());
  }

  /* ---------- Reveal ------------------------------------------ */
  function initReveal(root) {
    var targets = (root || document).querySelectorAll('.nt-reveal:not(.is-in)');
    if (!targets.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -80px 0px' }
    );
    targets.forEach(function (el) { io.observe(el); });
  }

  function boot() {
    initCounters(document);
    initReveal(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCounters(event.target);
    initReveal(event.target);
  });
})();
